<!-- Navigation -->
<nav class="navbar">
    <div class="container nav-container">
        <div class="nav-brand">
            <span class="brand-title brand-text-gradient">ODBUS</span>
            <span class="brand-subtitle">BUSINESS PARTNER</span>
        </div>
        <div class="nav-links">
            <a href="#features">Features</a>
            <a href="#earnings">Earnings</a>
            <a href="#routes">Routes</a>
            <a href="#faq">FAQ</a>
        </div>
        <div class="nav-actions">
            <button class="btn-login">Agent Login</button>
            <a href="#register" class="btn-primary">Register Now</a>
        </div>
    </div>
</nav>

<!-- Hero Section -->
<section class="hero gradient-bg">
    <div class="container hero-layout">
        <div class="hero-content">
            <span class="badge">Odisha's Premier Travel Agent Network</span>
            <h1 class="hero-title">
                Seats That Pay Higher. <br>
                <span class="text-orange">Earn More Every Ticket.</span>
            </h1>
            <p class="hero-desc">
                Maximize agency revenue with ODBUS. Access 1,000+ regional bus operators with 99.99% seat assurance. Stack commissions on tickets, insurance, and cancellation protection.
            </p>
            <div class="hero-features">
                <div>● Free Registration</div>
                <div>● Zero Setup Fees</div>
                <div>● 2-Minute Activation</div>
            </div>
        </div>
        
        <!-- Registration Form -->
        <div id="register" class="hero-form-wrapper">
            <div class="glass-card">
                <h3 class="form-title">Start Earning Today</h3>
                <p class="form-subtitle">Join 5,000+ successful ODBUS travel partners.</p>
                <form onsubmit="event.preventDefault(); alert('Registration submitted for processing!');">
                    <div class="form-group">
                        <label class="form-label">FULL NAME</label>
                        <input type="text" class="form-input" placeholder="Enter your full name">
                    </div>
                    <div class="form-group">
                        <label class="form-label">AGENCY / SHOP NAME</label>
                        <input type="text" class="form-input" placeholder="Your business name">
                    </div>
                    <div class="form-grid-2 form-group">
                        <div>
                            <label class="form-label">MOBILE NUMBER</label>
                            <input type="tel" class="form-input" placeholder="10-digit mobile">
                        </div>
                        <div>
                            <label class="form-label">CITY / TOWN</label>
                            <input type="text" class="form-input" placeholder="e.g. Sambalpur">
                        </div>
                    </div>
                    <button type="submit" class="btn-submit brand-gradient">Create Free Agent Account</button>
                </form>
            </div>
        </div>
    </div>
</section>

<!-- Stats Banner -->
<div class="stats-banner">
    <div class="container">
        <div class="stats-grid">
            <div>
                <div class="stat-value">1,000+</div>
                <div class="stat-label">Bus Operators</div>
            </div>
            <div>
                <div class="stat-value">500+</div>
                <div class="stat-label">Daily Routes</div>
            </div>
            <div>
                <div class="stat-value orange">99.99%</div>
                <div class="stat-label">Assured Seats</div>
            </div>
            <div>
                <div class="stat-value green">₹45k+</div>
                <div class="stat-label">Monthly Goal</div>
            </div>
            <div class="stat-span-2">
                <div class="stat-value">24/7</div>
                <div class="stat-label">Agent Support</div>
            </div>
        </div>
    </div>
</div>

<!-- Revenue Simulator Section -->
<section id="earnings" class="section-padding">
    <div class="container">
        <div class="section-header">
            <h2 class="section-title">Calculate Your Earning Potential</h2>
            <p class="section-desc">See how ODBUS commission stacking turns a single ticket booking into a massive revenue stream for your agency.</p>
        </div>

        <div class="calculator-grid">
            <div class="calc-box">
                <div>
                    <div class="slider-header">
                        <span>Tickets Booked Daily</span>
                        <span id="ticketCountLabel" class="slider-val">15</span>
                    </div>
                    <input type="range" id="ticketSlider" min="1" max="100" value="15" class="range-slider">
                </div>

                <div class="calc-details">
                    <div class="calc-row">
                        <div>
                            <div class="calc-label">Base Commission</div>
                            <div class="calc-sublabel">~8% per ticket fare (Avg ₹850)</div>
                        </div>
                        <div id="baseCommVal" class="calc-val">₹1,020</div>
                    </div>
                    <div class="calc-row green">
                        <div>
                            <div class="calc-label" style="color: #166534;">Add-on Bonuses</div>
                            <div class="calc-sublabel green">Insurance + Cancellation Stacking</div>
                        </div>
                        <div id="addonCommVal" class="calc-val green">+₹255</div>
                    </div>
                    <div class="calc-total">
                        <div class="total-label">Estimated Daily Profit</div>
                        <div id="totalDailyProfit" class="total-amount">₹1,275</div>
                    </div>
                </div>
            </div>

            <div class="chart-wrapper">
                <div class="chart-container">
                    <canvas id="incomeChart"></canvas>
                </div>
                <div class="chart-stats">
                    <div class="chart-label">Projected Monthly Earnings</div>
                    <div id="monthlyProfit" class="chart-val">₹38,250</div>
                    <p class="chart-note">*Estimates based on average ticket values and full margin stacking.</p>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- Profit Stacking Visual -->
<section class="profit-stacking gradient-bg">
    <div class="container">
        <h2 class="section-title" style="text-align: center; margin-bottom: 3rem;">The Revenue Stacking Advantage</h2>
        <div class="stack-grid">
            <div class="stack-card">
                <div class="stack-icon orange">1</div>
                <h4 class="stack-title">Base Commission</h4>
                <p class="stack-desc">Guaranteed percentage payouts on every AC, Sleeper, and Seater ticket across all operators.</p>
            </div>
            <div class="stack-card">
                <div class="stack-icon blue">2</div>
                <h4 class="stack-title">Insurance Bonus</h4>
                <p class="stack-desc">Earn lucrative add-on commissions on every travel insurance policy issued at checkout.</p>
            </div>
            <div class="stack-card">
                <div class="stack-icon green">3</div>
                <h4 class="stack-title">Protection Stack</h4>
                <p class="stack-desc">Earn extra revenue by protecting customer bookings against last-minute trip cancellations.</p>
            </div>
        </div>
    </div>
</section>

<!-- Features Grid -->
<section id="features" class="section-padding" style="background-color: #ffffff;">
    <div class="container">
        <div class="section-header">
            <h2 class="section-title">Built for Agency Success</h2>
            <p class="section-desc">Experience a booking portal that eliminates technical friction so you can focus on selling more tickets.</p>
        </div>

        <div class="features-grid">
            <div class="feature-card">
                <div class="feature-icon icon-orange">&#128187;</div>
                <h4 class="feature-title">Unified Dashboard</h4>
                <p class="feature-desc">Access 1,000+ local operators from one login. No more juggling multiple portals.</p>
            </div>
            <div class="feature-card">
                <div class="feature-icon icon-green">&#9889;</div>
                <h4 class="feature-title">Express 3-Step</h4>
                <p class="feature-desc">Search, Select, and Pay. Optimized for rapid counter issuance under pressure.</p>
            </div>
            <div class="feature-card">
                <div class="feature-icon icon-blue">&#9989;</div>
                <h4 class="feature-title">Assured Seats</h4>
                <p class="feature-desc">99.99% seat lock protocol. Protect your agency's reputation from double-bookings.</p>
            </div>
            <div class="feature-card">
                <div class="feature-icon icon-purple">&#128176;</div>
                <h4 class="feature-title">Instant Wallet</h4>
                <p class="feature-desc">Commissions credited instantly. Rapid refunds automated back to your agency wallet.</p>
            </div>
        </div>
    </div>
</section>

<!-- Regional Route Network -->
<section id="routes" class="section-padding">
    <div class="container">
        <div class="route-header-flex">
            <div style="max-width: 36rem;">
                <h2 class="section-title" style="text-align: left; margin-bottom: 1rem;">Deepest Route Penetration in Odisha</h2>
                <p class="section-desc" style="margin-left: 0;">Sell tickets for the routes your customers actually take. From coastal urban centers to interior industrial districts.</p>
            </div>
            <div class="route-tabs" id="routeTabs">
                <button onclick="switchRoute('coastal', event)" class="route-tab active">Coastal</button>
                <button onclick="switchRoute('western', event)" class="route-tab">Western</button>
                <button onclick="switchRoute('southern', event)" class="route-tab">Southern</button>
                <button onclick="switchRoute('interstate', event)" class="route-tab">Interstate</button>
            </div>
        </div>

        <div id="routeGrid" class="route-grid">
            <!-- Dynamic Content -->
        </div>
    </div>
</section>

<!-- Onboarding Process -->
<section class="section-padding" style="background-color: #ffffff;">
    <div class="container">
        <div class="section-header">
            <h2 class="section-title">How to Start Earning</h2>
            <p class="section-desc">Follow these 4 simple steps to go live on the ODBUS network.</p>
        </div>

        <div class="step-flex">
            <div class="step-item">
                <div class="step-number brand-gradient step-line">1</div>
                <h4 class="step-title">Register</h4>
                <p class="step-desc">Fill the 60-second online form with shop details.</p>
            </div>
            <div class="step-item">
                <div class="step-number brand-gradient step-line">2</div>
                <h4 class="step-title">KYC Verify</h4>
                <p class="step-desc">Submit PAN/Aadhaar for instant digital verification.</p>
            </div>
            <div class="step-item">
                <div class="step-number brand-gradient step-line">3</div>
                <h4 class="step-title">Load Wallet</h4>
                <p class="step-desc">Add funds instantly via UPI or NetBanking.</p>
            </div>
            <div class="step-item">
                <div class="step-number brand-gradient">4</div>
                <h4 class="step-title">Start Earnings</h4>
                <p class="step-desc">Book tickets, stack add-ons & earn top margins.</p>
            </div>
        </div>
    </div>
</section>

<!-- FAQ Accordion -->
<section id="faq" class="section-padding">
    <div class="container">
        <h2 class="section-title" style="margin-bottom: 3rem;">Frequently Asked Questions</h2>
        <div class="faq-wrapper">
            <div class="faq-item">
                <button onclick="toggleFaq(0)" class="faq-btn">
                    <span class="faq-question">Are there any setup or membership fees?</span>
                    <span class="faq-icon">+</span>
                </button>
                <div class="faq-content hidden">
                    No. Joining the ODBUS Agent Network is completely free. There are no upfront setup fees, recurring subscription charges, or hidden platform maintenance costs.
                </div>
            </div>
            <div class="faq-item">
                <button onclick="toggleFaq(1)" class="faq-btn">
                    <span class="faq-question">How are commission payouts processed?</span>
                    <span class="faq-icon">+</span>
                </button>
                <div class="faq-content hidden">
                    Commissions are calculated instantly upon every successful ticket issuance and credited directly to your agent wallet balance. You can use your commission balance immediately to book subsequent tickets.
                </div>
            </div>
            <div class="faq-item">
                <button onclick="toggleFaq(2)" class="faq-btn">
                    <span class="faq-question">What happens if a customer cancels a ticket?</span>
                    <span class="faq-icon">+</span>
                </button>
                <div class="faq-content hidden">
                    Refunds are determined by the specific operator's policy. The refund amount is credited back to your agent wallet immediately. If you booked with Cancellation Protection, the passenger receives enhanced refund terms.
                </div>
            </div>
            <div class="faq-item">
                <button onclick="toggleFaq(3)" class="faq-btn">
                    <span class="faq-question">How do I get help with a booking?</span>
                    <span class="faq-icon">+</span>
                </button>
                <div class="faq-content hidden">
                    ODBUS maintains a 24/7 dedicated regional support desk. You can reach us at 9583918888 or via email at support@odbus.in for instant resolution of trip or payment issues.
                </div>
            </div>
        </div>
    </div>
</section>

<!-- Footer -->
<footer class="footer">
    <div class="container">
        <div class="footer-grid">
            <div class="footer-brand-col">
                <div class="footer-logo">ODBUS</div>
                <p class="footer-text">
                    ODBUS is Odisha’s leading digital bus ticketing ecosystem, connecting 1,000+ operators to a nationwide network of travel partners. Established in 2015 to revolutionize regional travel connectivity.
                </p>
                <div class="footer-socials">
                    <a href="#">f</a>
                    <a href="#">in</a>
                    <a href="#">x</a>
                </div>
            </div>
            <div>
                <h4 class="footer-title">Contact Us</h4>
                <ul class="footer-list">
                    <li>9583918888 / 9438654942</li>
                    <li>support@odbus.in</li>
                    <li>Bhubaneswar, Odisha</li>
                </ul>
            </div>
            <div>
                <h4 class="footer-title">B2B Quick Links</h4>
                <ul class="footer-list">
                    <li><a href="#">Agent Agreement</a></li>
                    <li><a href="#">Commission Policy</a></li>
                    <li><a href="#">Help Desk</a></li>
                    <li><a href="#">Privacy Policy</a></li>
                </ul>
            </div>
        </div>
        <div class="footer-bottom">
            &copy; 2026 OD Tours & Travels Private Limited. All Rights Reserved.
        </div>
    </div>
</footer>
<script>
    // --- Data Objects ---
    const routeData = {
        coastal: [
            { from: 'Bhubaneswar', to: 'Puri', ops: 'Chandan Bus' },
            { from: 'Cuttack', to: 'Berhampur', ops: 'Devdas Travels' },
            { from: 'Bhubaneswar', to: 'Balasore', ops: 'Binapani' },
            { from: 'Bhubaneswar', to: 'Baripada', ops: 'Ananya Srikunj' },
            { from: 'Puri', to: 'Konark', ops: 'Local Express' },
            { from: 'Bhadrak', to: 'Bhubaneswar', ops: 'Jagannath' },
            { from: 'Berhampur', to: 'Puri', ops: 'Maa Kali' },
            { from: 'Cuttack', to: 'Balasore', ops: 'Grand Coastal' }
        ],
        western: [
            { from: 'Bhubaneswar', to: 'Rourkela', ops: 'Green Baloon' },
            { from: 'Bhubaneswar', to: 'Sambalpur', ops: 'Sampark' },
            { from: 'Cuttack', to: 'Jharsuguda', ops: 'Shakti' },
            { from: 'Bhubaneswar', to: 'Balangir', ops: 'Sai Darshan' },
            { from: 'Sambalpur', to: 'Bargarh', ops: 'Maa Manikeswari' },
            { from: 'Rourkela', to: 'Jharsuguda', ops: 'Super Western' },
            { from: 'Bhubaneswar', to: 'Sonepur', ops: 'Gourav Bus' },
            { from: 'Cuttack', to: 'Nuapada', ops: 'Panchayat' }
        ],
        southern: [
            { from: 'Bhubaneswar', to: 'Rayagada', ops: 'Maa Thakurani' },
            { from: 'Bhubaneswar', to: 'Koraput', ops: 'Annapurna' },
            { from: 'Cuttack', to: 'Jeypore', ops: 'Mahadev' },
            { from: 'Cuttack', to: 'Malkangiri', ops: 'Satya Bus' },
            { from: 'Berhampur', to: 'Phulbani', ops: 'Gajapati' },
            { from: 'Bhubaneswar', to: 'Bhawanipatna', ops: 'Sun Express' },
            { from: 'Jeypore', to: 'Malkangiri', ops: 'Tribal King' },
            { from: 'Bhubaneswar', to: 'Gunupur', ops: 'Southern Star' }
        ],
        interstate: [
            { from: 'Kolkata', to: 'Bhubaneswar', ops: 'Mallick Bus' },
            { from: 'Ranchi', to: 'Bhubaneswar', ops: 'Grand Express' },
            { from: 'Raipur', to: 'Sambalpur', ops: 'SBP Express' },
            { from: 'Bhubaneswar', to: 'TATA', ops: 'Satya Travels' },
            { from: 'Surat', to: 'Bhubaneswar', ops: 'Pradhan Bus' },
            { from: 'Vizag', to: 'Berhampur', ops: 'Andhra Exp' },
            { from: 'Kolkata', to: 'Puri', ops: 'Holiday Spl' },
            { from: 'Chennai', to: 'Berhampur', ops: 'Coastal Long' }
        ]
    };

    // --- State & Chart Initialization ---
    let incomeChart;
    const ticketSlider = document.getElementById('ticketSlider');
    const ticketCountLabel = document.getElementById('ticketCountLabel');
    const baseCommVal = document.getElementById('baseCommVal');
    const addonCommVal = document.getElementById('addonCommVal');
    const totalDailyProfit = document.getElementById('totalDailyProfit');
    const monthlyProfit = document.getElementById('monthlyProfit');

    function initChart() {
        const ctx = document.getElementById('incomeChart').getContext('2d');
        incomeChart = new Chart(ctx, {
            type: 'bar',
            data: {
                labels: ['Daily Profit', 'Weekly Profit', 'Monthly Profit'],
                datasets: [{
                    label: 'Income Projection (₹)',
                    data: [0, 0, 0],
                    backgroundColor: ['#E4532B', '#111827', '#10B981'],
                    borderRadius: 8,
                    maxBarThickness: 50
                }]
            },
            options: {
                maintainAspectRatio: false,
                responsive: true,
                plugins: { legend: { display: false } },
                scales: {
                    y: {
                        beginAtZero: true,
                        grid: { display: false }
                    },
                    x: {
                        grid: { display: false }
                    }
                }
            }
        });
    }

    // --- Logic Functions ---
    function updateIncome() {
        const count = parseInt(ticketSlider.value);
        const avgFare = 850;
        const baseComm = Math.round(count * avgFare * 0.08);
        const addonComm = Math.round(count * 17); // ~ ₹17 extra profit per ticket from add-ons
        const daily = baseComm + addonComm;
        const monthly = daily * 30;

        ticketCountLabel.innerText = count;
        baseCommVal.innerText = `₹${baseComm.toLocaleString()}`;
        addonCommVal.innerText = `+₹${addonComm.toLocaleString()}`;
        totalDailyProfit.innerText = `₹${daily.toLocaleString()}`;
        monthlyProfit.innerText = `₹${monthly.toLocaleString()}`;

        // Update Chart
        incomeChart.data.datasets[0].data = [daily, daily * 7, monthly];
        incomeChart.update();
    }

    function switchRoute(zone, evt) {
        // Update Tabs UI
        document.querySelectorAll('.route-tab').forEach(tab => {
            tab.classList.remove('active');
        });
        if (evt) {
            evt.target.classList.add('active');
        } else {
            const defaultTab = document.querySelector('.route-tab');
            if (defaultTab) defaultTab.classList.add('active');
        }

        // Update Grid
        const grid = document.getElementById('routeGrid');
        grid.innerHTML = '';
        routeData[zone].forEach(item => {
            const card = document.createElement('div');
            card.className = "route-card";
            card.innerHTML = `
                <div>
                    <div class="route-path">
                        <span>${item.from}</span>
                        <span>&#8594;</span>
                        <span>${item.to}</span>
                    </div>
                    <div class="route-ops">${item.ops}</div>
                </div>
                <div class="route-status">
                    <span class="status-dot"></span>
                    <span class="status-text">Live Availability</span>
                </div>
            `;
            grid.appendChild(card);
        });
    }

    function toggleFaq(index) {
        const contents = document.querySelectorAll('.faq-content');
        const content = contents[index];
        const isHidden = content.classList.contains('hidden');
        
        // Close others
        contents.forEach(c => c.classList.add('hidden'));
        
        if (isHidden) {
            content.classList.remove('hidden');
        }
    }

    // --- Initializations ---
    window.onload = () => {
        initChart();
        updateIncome();
        switchRoute('coastal');
        
        ticketSlider.addEventListener('input', updateIncome);
    };
</script>